import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { UtilService } from '@services/index';
import { CtrlAccess } from '@services/util/ctrlAccess';

interface AccessGuardRouteData {
    codeModuleList?: string[];
}

@Injectable({ providedIn: 'root' })
export class AccessGuard implements CanActivate {
    private ctrlAccess = new CtrlAccess();
    private router = inject(Router);
    private util = inject(UtilService);

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const user = this.util.getUserSession();

        // vérifie que l'utilisateur est connecté, sinon redirige vers la page de connexion
        if (!user) {
            this.router.navigate(['/auth']).catch(e => this.util.fErreur(e));
            return false;
        }

        this.ctrlAccess.setUtilisateur(user, this.util.superAdmin);

        // vérifie que l'utilisateur a les droits d'accès au module, sinon redirige vers la page d'inaccessibilité
        const codeModuleList = (route.data as AccessGuardRouteData).codeModuleList;

        if (codeModuleList) {
            // Accès ok si au moins un des modules est ok
            let ctrlAccessOK = false;
            codeModuleList.forEach(codeModule => {
                if (this.ctrlAccess.ctrlAccessOK(codeModule)) {
                    ctrlAccessOK = true;
                }
            });
            if (!ctrlAccessOK) {
                this.router.navigate(['/pageinaccessible']).catch(e => this.util.fErreur(e));
                return false;
            }
        }
        return true;
    }
}
